import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    padding: '2rem 0',
    textAlign: 'center',
    color: theme.palette.primary.main,
    fontFamily: 'Roboto Slab',
  },
}));

const PageTitle = ({ children }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.root} data-testid="page-title_root">
      <Typography variant="h4" component="div" className={classes.title}>
        {children}
      </Typography>
    </Grid>
  );
};

export default PageTitle;
